/*
 * @Description: 地域设置
 * @Author: zhaoqing
 * @LastEditors  : pu.yuchun
 * @Date: 2019-09-17 15:44:35
 * @LastEditTime : 2020-01-04 13:17:38
 */
angular.module('regionSettingModule', []).controller('regionSettingCtrl', [
    '$scope',
    '$q',
    'modalDialog',
    'trsHttpService',
    function($scope, $q, modalDialog, trsHttpService) {
        // token 和租户 id
        var token = '',
            tenantId = '';

        $scope.treeData = [];
        // tree 组件配置
        $scope.treeOptions = {
            nodeChildren: 'childlist',
            dirSelectable: true,
            allowDeselect: false,
            injectClasses: {
                ul: 'a1 manage-tree',
                li: 'a2',
                liSelected: 'a7',
                iExpanded: 'icon-previewright a3',
                iCollapsed: 'icon-previewright a4',
                iLeaf: 'a5',
                label: 'a6',
                labelSelected: 'rolegrouplabselected'
            },
            isLeaf: function(node) {
                return node.noChildren;
            }
        };
        // 节点详情
        $scope.detail = {};

        // 获取根树节点
        function getTreeData() {
            $scope.loadingPromise = trsHttpService
                .httpServer(
                    '/api/tenantcenter/region/getTopLayerRegion',
                    {
                        tenantId: tenantId
                    },
                    'get',
                    '',
                    { token: token }
                )
                .then(function(data) {
                    if (data.code !== '200') return;
                    // 请求被勾选的树节点
                    getModuleTree(data.datas);
                });
        }

        // 获取当前登录人的信息 获取token
        function getCurrentInfo() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getCurrUserInfo'
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.TENANTID) {
                        tenantId = data.TENANTID;
                        getToken(deffer.resolve);
                    }
                });
            return deffer.promise;
        }

        // 获取token
        function getToken(resolve) {
            var params = {
                serviceid: 'getToken',
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.token) {
                        token = data.token;
                        resolve();
                    }
                });
        }

        // 获取 token 后 ，请求树节点
        getCurrentInfo().then(function() {
            getTreeData();
        });

        // 获取已经被选择的tree
        function getModuleTree(treeData, parentItem, areaNum) {
            var params = {
                tenantId: tenantId,
                areaNum: areaNum || ''
            };
            $scope.loadingPromise = trsHttpService
                .httpServer('/api/tenantcenter/region/getRegionTree', params, 'get', '', {
                    token: token
                })
                .then(function(data) {
                    if (parentItem) {
                        parentItem.childlist = treeData;
                    } else {
                        $scope.treeData = treeData;
                    }
                    if (data.datas) {
                        var ids = [];
                        traverse(data.datas, function(item) {
                            ids.push(item.areanum);
                        });
                        traverse(treeData, function(item) {
                            if (includes(ids, item.areanum)) item.checked = true;
                        });
                    }
                });
        }

        // 点击节点 获取详情
        $scope.selectHandler = function(node) {
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/region/findById', { areaNum: node.areanum }, 'get', '', { token: token }).then(res => {
                if (res.code === '200') {
                    $scope.detail = {
                        dictname: res.datas.dictname,
                        content: res.datas.content
                    };
                } else if (node.dictname && node.content) {
                    $scope.detail = {
                        dictname: node.dictname,
                        content: node.content
                    };
                } else {
                    modalDialog.saveModel('提示', res.msg || '获取失败', 'success', false);
                }
            });
        };
        // 展开节点
        $scope.showToggle = function(node) {
            if (node.noChildren || node.childlist.length) return;
            var params = {
                areaNum: node.areanum
            };
            $scope.loadingPromise = trsHttpService.httpServer('/api/tenantcenter/region/getRegionList', params, 'get', '', { token: token }).then(res => {
                if (res.code === '200' && res.datas && res.datas.length) {
                    getModuleTree(res.datas, node, node.areanum);
                } else {
                    node.noChildren = true;
                }
            });
        };

        // 选择节点
        $scope.checkNode = function(node) {
            save(node);
        };

        // 保存
        function save(node) {
            var id = node.areanum;
            var params = {
                areaNum: id,
                tenantId: tenantId
            };
            $scope.loadingPromise = trsHttpService
                .httpServer('/api/tenantcenter/region/bindOrUnBindRegions', params, 'post', '', {
                    token: token
                })
                .then(function(data) {
                    if (data.code === '200') {
                        node.checked = !node.checked;
                    } else {
                        modalDialog.alertType('提示', data.msg || '保存失败', 'error', 'confirm', function() {});
                    }
                });
        }

        // 递归遍历
        function traverse(arr, fn) {
            arr.forEach(function(item) {
                fn(item);
                item.childlist && traverse(item.childlist, fn);
            });
        }

        // includes
        function includes(arr, item) {
            return arr.indexOf(item) !== -1;
        }

        return false;
    }
]);
